import { bindable, transient, autoinject, computedFrom } from "aurelia-framework";
import { AllAttachments } from "./tabs/all-attachments/all-attachments";
import { Router } from "aurelia-router";
import { CacheClientService } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { TabModel } from "@rightship-tech/common-ui/models/basic.models";
import { GuidHelper } from "@rightship-tech/common-ui/helpers/guid.helper";
import { AttachmentViewerExecutionModel } from "@rightship-tech/common-ui/models/attachments.models";


@autoinject
@transient()
export class InspectionDetailsDrawer {

    drawerBigger: boolean = true;
    
    @bindable
    public attachments: any;

    @bindable
    public showInspectionDetailsDrawer: boolean;

    @bindable
    public executionModel: AttachmentViewerExecutionModel;
    public tabs: TabModel[];
    private _currentTab: TabModel;
    private _newTabIdentifier: string;

    constructor(private allAttachments: AllAttachments, public router: Router, public cacheService: CacheClientService){
    }

    getTitle(title: string, count: number) {
        return title + " (" + count + ")";
    }

    attached() {
        this.tabs = [
            {
                title: () => this.executionModel.count ? this.getTitle(this.executionModel.title, this.executionModel.count) : this.executionModel.title,
                step: 1,
                show: true,
                vm: this.allAttachments,
                getModel: () => {
                    this._newTabIdentifier = GuidHelper.generateGuid(); 
                    return {
                        getAttachmentDocuments: this.executionModel.getAttachmentDocuments,
                        newTabIdentifier: this._newTabIdentifier,
                        selectedThumbnailId: this.executionModel.selectedThumbnailId
                    }
                }
            }
        ];
    }

    toggleVesselMoreDetailsDrawer(){
        this.showInspectionDetailsDrawer = !this.showInspectionDetailsDrawer;
    }

    toggleDrawerBigger(){
        this.drawerBigger = !this.drawerBigger;
    }


    tabChanged(event:any){
        this._currentTab = null;
        const step = event.detail?.step;
        if (step === undefined) {
            return;
        }

        setTimeout(() => {
            const tab = this.tabs.filter(x=>x.step == step)[0];
            this._currentTab = tab
        });
    }
    
    openNewTab() {
        window.open(`/attachment-viewer?id=${this._newTabIdentifier}&openInNewTab=true`, "_blank");
        this.showInspectionDetailsDrawer = false;
    }

    @computedFrom("_currentTab")
    get currentTab(){
        return this._currentTab;
    }
}